import React, { useCallback, useMemo, useState } from 'react';
import { Table, Segment, Form } from 'semantic-ui-react';
import styles from './Wallet.module.scss';
import WalletItem from './WalletItem';
import EditWalletModal from './EditWalletModal';

const Wallet = ({ wallet, color, onChange, payment, actions, userEmailAddress }) => {
	const [editWalletOpen, setEditWalletOpen] = useState(false);

	const _onChange = useCallback(() => {
		setEditWalletOpen(false);

		if (onChange) onChange();
	}, [onChange]);

	const inUse = useMemo(() => (wallet.wallets || []).some(w => w.inUse), [wallet.wallets]);

	return (
		<Segment className={styles.wallet} color={color}>
			<div className={styles.account}>
				<Form>
					<Form.Field inline>
						<label>Email</label>
						{wallet.consumerEmail && <span>{wallet.consumerEmail}</span>}
						{!wallet.consumerEmail && (
							<span>
								<i>not set</i>
							</span>
						)}
					</Form.Field>
				</Form>
				<div className={styles.edit}>
					<EditWalletModal wallet={wallet} open={editWalletOpen} onOpen={() => setEditWalletOpen(true)} onClose={() => setEditWalletOpen(false)} onSave={_onChange} payment={payment} actions={actions} userEmailAddress={userEmailAddress} />
				</div>
			</div>

			<div className={styles.items}>
				<Table>
					<Table.Header>
						<Table.Row>
							<Table.HeaderCell width={5}>Nickname</Table.HeaderCell>
							<Table.HeaderCell>Payment Method</Table.HeaderCell>
							{inUse &&
								<Table.HeaderCell>In Use By</Table.HeaderCell>
							}
							<Table.HeaderCell width={3}></Table.HeaderCell>
						</Table.Row>
					</Table.Header>
					<Table.Body>
						{(wallet.wallets || []).map((walletItem, i) => {
							return <WalletItem key={i} walletItem={walletItem} onChange={_onChange} payment={payment} actions={actions} userEmailAddress={userEmailAddress} walletInUse={inUse} />;
						})}
					</Table.Body>
				</Table>
			</div>
		</Segment>
	);
};

export default Wallet;
